import React, { useState } from "react";
import LuvitComponent from "LuvitComponent";
import Pie from "lib/components/charts/pie.jsx";
import { autobind } from "lib/decorators";
import CategoryDropdown from "./category-dropdown";
import { IconButton } from "lib/components/Button";
import SettingStore from "stores/settings";
import * as CONSTANTS from "./constants";
import styled from "styled-components";
import FilterButtons from "Components/Fragment/FilterButtons";
import SearchField from "Components/Fragment/SearchField";
import { Box } from "Components/Base/Layout/Box";

const StyledFilterButtons = styled(FilterButtons)`
  margin-right: 16px;
`;

const SORT_TITLE = "title";
const SORT_LAST_LOGGED_IN = "lastloggedin";
const SORT_CREATED_DATE = "createddate";

@autobind
export default class Filter extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "ActivityCentre");

    window.onhashchange = this.locationHashChanged;
  }

  componentWillMount() {
    this.setState({ ...this.props.store.filter });
  }

  componentDidMount() {
    this.filterByQueryString();
  }

  componentDidUpdate(prevProps, prevState) {
    let changed = false;
    changed = changed || prevState.searchText != this.state.searchText;
    changed = changed || prevState.selectedTags != this.state.selectedTags;
    changed = changed || prevState.categoryId != this.state.categoryId;
    changed =
      changed ||
      prevState.hideAdministratorCourses !=
        this.state.hideAdministratorCourses ||
      prevState.hideParticipantCourses != this.state.hideParticipantCourses;
    if (changed) {
      this.doSearch();
    }
  }

  locationHashChanged() {
    if (window.location.href.indexOf("?") > -1) {
      this.filterByQueryString();
      this.doSearch();
    } else if (this.state.categoryId !== 0) {
      this.setState({ searchText: "", categoryId: 0 });
    }
  }

  doSearch() {
    this.props.store.search({
      searchText: this.state.searchText,
      categoryId: this.state.categoryId,
      selectedTags: this.state.selectedTags,
      sortBy: this.state.sortBy,
      hideAdministratorCourses: this.state.hideAdministratorCourses,
      hideParticipantCourses: this.state.hideParticipantCourses,
      mode: this.props.mode,
    });
  }

  getTag = (queryTag) => {
    let tags = this.props.store.tags.slice();
    let tag = tags.filter((tag) => tag.title == queryTag);

    return tag.slice()[0];
  };

  getCategoryID = (queryTag) => {
    let categorys = Object.values(this.props.store.categories);
    let category = categorys.filter(
      (category) => category.categoryTitle.toLowerCase() == queryTag,
    );
    return category[0] ? category[0].trainingCategoryId : 0;
  };

  getTagValue = (tagData, tagValue) => {
    if (tagData && tagValue) {
      let tag = tagData.values.filter(
        (tag) => tag.title.toLowerCase() == tagValue,
      );
      return tag.slice()[0].valueId;
    }
    return null;
  };

  filterByQueryString = () => {
    if (SettingStore.getSettingValue("mycoursesfiltertags")) {
      let tagString = SettingStore.getSettingValue("mycoursesfiltertags");
      let tags = SettingStore.getSettingValue("mycoursesfiltertags").split(",");

      for (let tag of tags) {
        let tagValue = luvit.GetQueryString(tag);
        if (tagValue) {
          let valueID = 0;
          if (tag === "category") {
            valueID = this.getCategoryID(tagValue);
            this.setState({ categoryId: valueID });
          } else {
            let tagData = this.getTag(tag);
            valueID = this.getTagValue(tagData, tagValue);
            this.setTagFilter(0, valueID);
          }
        }
      }
    }
  };

  setFilter(f) {
    let filter;
    if (f !== this.props.store.filter.filter) {
      filter = f;
    }
    this.props.store.setFilter(filter);
  }

  setSortBy(sortBy) {
    this.setState({ sortBy });
    this.props.store.setSortBy(sortBy);
  }

  setTagFilter(no, value) {
    let selectedTags = [...this.state.selectedTags];
    selectedTags[no] = value;
    this.setState({ selectedTags });
  }

  setSearchText(searchText) {
    this.setState({ searchText });
  }

  renderTagFilters() {
    return this.props.store.tags.map((tag, i) => {
      let values = tag.values.map((o) => (
        <option key={o.valueId} value={o.valueId} data-tag={o.title}>
          {o.title}
        </option>
      ));
      return (
        <div key={tag.categoryId} className="cardview-filter-section-select">
          <label htmlFor={`${this.l("filter")}-${tag.title}`}>
            {this.l(tag.title)}
          </label>
          <select
            aria-label={`${this.l("filter")}-${tag.title}`}
            name={`${this.l("filter")}-${tag.title}`}
            id={`${this.l("filter")}-${tag.title}`}
            key={tag.id}
            onChange={(e) => this.setTagFilter(i, e.target.value)}
          >
            <option value="all">{this.l("all")}</option>
            {values}
          </select>
        </div>
      );
    });
  }

  renderSubFilters() {
    const { filteredCourses, filteredPrograms } = this.props.store;

    let leftToDoPrograms = [];
    let startedPrograms = [];
    let completedPrograms = [];

    if (filteredPrograms.lefttodo) {
      leftToDoPrograms = filteredPrograms.lefttodo.length;
    }

    if (filteredPrograms.begun) {
      startedPrograms = filteredPrograms.begun.length;
    }

    if (filteredPrograms.completed) {
      completedPrograms = filteredPrograms.completed.length;
    }

    let leftToDo = filteredCourses.lefttodo.length + leftToDoPrograms;
    let started = filteredCourses.begun.length + startedPrograms;
    let completed = filteredCourses.completed.length + completedPrograms;

    const buttons = [
      { value: this.l("all"), filter: CONSTANTS.PROGRESS_ALL },
      {
        value: `${this.l("lefttodo")} (${leftToDo})`,
        filter: CONSTANTS.FILTER_TODO,
      },
      {
        value: `${this.l("begun")} (${started})`,
        filter: CONSTANTS.FILTER_ONGOING,
      },
      {
        value: `${this.l("Finished2")} (${completed})`,
        filter: CONSTANTS.FILTER_DONE,
      },
    ];

    return (
      <div>
        {this.props.mode === CONSTANTS.MODE_FULL && (
          <StyledFilterButtons
            buttons={buttons}
            onSelectFilter={this.setFilter.bind(this)}
          />
        )}
      </div>
    );
  }

  renderHideAdministratorCourses() {
    if (!this.props.store.isAdmin) return null;
    return (
      <div>
        <div className="cardview-subfilter-admincheck flex align-c">
          <input
            type="checkbox"
            id="ChkOnlyCourseParticipantsCourses"
            checked={!!this.state.hideAdministratorCourses}
            onChange={(e) => {
              let hideParticipantCourses = e.target.checked
                ? false
                : this.state.hideParticipantCourses;
              this.setState({
                hideAdministratorCourses: !this.state.hideAdministratorCourses,
                hideParticipantCourses,
              });
            }}
          />
          <label htmlFor="ChkOnlyCourseParticipantsCourses">
            {this.l("hideadministratorcourses")}
          </label>
          &nbsp;&nbsp;
        </div>
        <IconButton
          style={
            this.state.hideAdministratorCourses
              ? { color: "green" }
              : { color: "black" }
          }
          label={
            this.state.hideAdministratorCourses
              ? this.l("showadministratorcourses")
              : this.l("hideadministratorcourses")
          }
          icon={
            this.state.hideAdministratorCourses
              ? "icon-graduation on"
              : "icon-graduation"
          }
          onClick={() =>
            this.setState({
              hideAdministratorCourses: !this.state.hideAdministratorCourses,
              hideParticipantCourses: false,
            })
          }
        />
      </div>
    );
  }

  renderHideParticipantCourses() {
    if (!this.props.store.isAdmin) return null;
    return (
      <div>
        <div className="cardview-subfilter-admincheck flex align-c">
          <input
            type="checkbox"
            id="ChkOnlyAdminCourses"
            checked={!!this.state.hideParticipantCourses}
            onChange={(e) => {
              let hideAdministratorCourses = e.target.checked
                ? false
                : this.state.hideAdministratorCourses;
              this.setState({
                hideParticipantCourses: !this.state.hideParticipantCourses,
                hideAdministratorCourses,
              });
            }}
          />
          <label htmlFor="ChkOnlyAdminCourses">
            {this.l("hideParticipantCourses")}
          </label>
          &nbsp;&nbsp;
        </div>
        <IconButton
          style={
            this.state.hideParticipantCourses
              ? { color: "green" }
              : { color: "black" }
          }
          label={
            this.state.hideParticipantCourses
              ? this.l("showparticipantcourses")
              : this.l("hideparticipantcourses")
          }
          icon={
            this.state.hideParticipantCourses ? "icon-admin on" : "icon-admin"
          }
          onClick={() =>
            this.setState({
              hideParticipantCourses: !this.state.hideParticipantCourses,
              hideAdministratorCourses: false,
            })
          }
        />
      </div>
    );
  }

  renderCategories() {
    let store = this.props.store;
    let categoryId = this.state.categoryId;
    let ancestors = [];
    for (
      let cat = categoryId;
      cat;
      cat = this.props.store.categories[cat].parentId
    ) {
      ancestors.unshift(cat);
    }
    ancestors.unshift(0);

    let dropdowns = ancestors.map((categoryId, i) => {
      let children = store.categoryHierarchy[categoryId] || [];
      if (!children.length) return null;

      let selected = ancestors[i + 1] || -1;
      return (
        <CategoryDropdown
          key={categoryId}
          parentId={categoryId}
          selected={selected}
          onChange={(categoryId) => this.setState({ categoryId })}
          options={children}
        />
      );
    });

    if (!dropdowns[0]) return null;

    return (
      <div className="cardview-filter-section">
        <label>{this.l("category")}</label>
        <div className="flex cardview-categories">{dropdowns}</div>
      </div>
    );
  }

  renderFilter() {
    let show =
      this.props.mode !== CONSTANTS.MODE_FULL ||
      this.props.mediaClass === "small" ||
      this.props.mediaClass === "x-small";
    if (!show) return null;
    return (
      <select
        aria-label={this.l("filter")}
        name={this.l("filter")}
        value={this.props.store.filter.filter}
        onChange={(e) => this.setFilter(e.target.value)}
      >
        <option value="all">{this.l("all")}</option>
        <option value="lefttodo">{this.l("lefttodo")}</option>
        <option value="notstarted">{this.l("notstarted")}</option>
        <option value="begun">{this.l("begun")}</option>
        <option value="completed">{this.l("finished2")}</option>
      </select>
    );
  }

  renderSort() {
    let show = this.props.mode === CONSTANTS.MODE_FULL;
    if (!show) return null;
    return (
      <select
        aria-label={this.l("sort")}
        name={this.l("sort")}
        onChange={(e) => this.setSortBy(e.target.value)}
        value={this.state.sortBy}
      >
        <option value={SORT_TITLE}>{this.l("lettersorting")}</option>
        <option value={SORT_LAST_LOGGED_IN}>
          {this.l("recentlyaccessed")}
        </option>
        <option value={SORT_CREATED_DATE}>{this.l("recentlyenrolled")}</option>
      </select>
    );
  }

  renderTxtSearch() {
    return (
      <div className="cardview-filter-section flex flex-column-gap-8 align-end">
        <Box mb={0.25} className="searchbox">
          <SearchField
            value={this.state.searchText}
            ariaLabel={this.l("searchinmylearning")}
            placeholder={this.l("search")}
            clearLabel={this.l("clearSearch")}
            onChange={(e) => this.setSearchText(e.target.value)}
            onClear={() => this.setSearchText("")}
          />
        </Box>
        <button
          className="margin-l-10 togglefilter"
          onClick={() => this.setState({ showFilter: !this.state.showFilter })}
        >
          {this.state.showFilter ? this.l("close") : this.l("filter")}
        </button>
      </div>
    );
  }

  renderPieChart() {
    return (
      <div className="cardview-filter-section totalprogress">
        <Pie
          style={{ height: 110, width: 110 }}
          titleConfig={{ color: "#0b537e", titleFontSize: "22px", y: 25 }}
          value={this.props.totalPercentCompleted + "%"}
          data={[
            {
              name: this.l("finished2"),
              color: "#fff",
              y: this.props.totalPercentCompleted,
            },
            {
              name: this.l("remaining"),
              color: "#000",
              y: 100 - this.props.totalPercentCompleted,
            },
          ]}
          legendConfig={{ enabled: false }}
          margin="0"
        />
      </div>
    );
  }

  doRender() {
    let display = "inherit";
    let mobileViewport = this.props.mediaClass === "x-small";
    let showCourseStatuses = true;
    if (
      this.props.mediaClass === "small" ||
      this.props.mediaClass === "x-small"
    ) {
      showCourseStatuses = false;
      if (this.state.showFilter) {
        display = "block";
      } else {
        display = "none";
      }
    }

    let filters = (
      <div>
        <div
          className={
            "cardview-subfilter flex flex-space-b align-c flex-wrap " +
            this.props.mediaClass
          }
        >
          {!mobileViewport && (
            <div className="cardview-hits">
              <strong>
                {this.l("hits")}
                :&nbsp;
              </strong>
              <span className="animated pulse">{this.props.hitCount}</span>
            </div>
          )}
          {showCourseStatuses && this.renderSubFilters()}
          {this.props.mode === CONSTANTS.MODE_FULL &&
            (this.props.mediaClass === "x-small" ||
              this.props.mediaClass === "small") &&
            this.renderTxtSearch()}
          <div
            className={
              !mobileViewport &&
              (this.props.mediaClass !== "x-small" ||
                this.props.mediaClass !== "small")
                ? "flex align-c flex-end"
                : ""
            }
          >
            {this.renderFilter()}
            {this.renderSort()}
          </div>
          <div className="flex hide-courses-icons">
            {this.renderHideAdministratorCourses()}
            {this.renderHideParticipantCourses()}
          </div>
        </div>
      </div>
    );

    return (
      <div>
        <div
          className={
            this.props.mode === CONSTANTS.MODE_FULL
              ? "cardview-filter flex " + this.props.mediaClass
              : "hidden"
          }
          role="search"
        >
          <div className="flex flex-wrap catsandtags" style={{ display }}>
            {this.renderCategories()}
            {this.renderTagFilters()}

            {this.renderTxtSearch()}
          </div>
          {this.renderPieChart()}
        </div>
        {this.props.store.searching ? null : filters}
        {this.props.mode !== CONSTANTS.MODE_FULL && (
          <div>{this.renderTxtSearch()}</div>
        )}
      </div>
    );
  }
}

const FilterHideAdministratorCourses = (props) => {
  if (!props.store.isAdmin) return null;
  const { lang } = props;
  const [hideAdministratorCourses, setHideAdministratorCourses] =
    useState(false);

  return (
    <div>
      <div className="cardview-subfilter-admincheck flex align-c">
        <input
          type="checkbox"
          id="ChkOnlyCourseParticipantsCourses"
          checked={!!hideAdministratorCourses}
          onChange={() =>
            setHideAdministratorCourses(!hideAdministratorCourses)
          }
        />
        <label htmlFor="ChkOnlyCourseParticipantsCourses">
          {lang("hideadministratorcourses")}
        </label>
        &nbsp;&nbsp;
      </div>
      <IconButton
        label={
          hideAdministratorCourses
            ? lang("showadministratorcourses")
            : lang("hideadministratorcourses")
        }
        icon={
          hideAdministratorCourses ? "icon-graduation on" : "icon-graduation"
        }
        onClick={() => setHideAdministratorCourses(!hideAdministratorCourses)}
      />
    </div>
  );
};

export { FilterHideAdministratorCourses };
